import { Component, Input } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { CptGoogleTagmanagerService } from '@inside-hub-app/customer-portal-shared'
import { SharedService } from '../../../../services/shared.service'
import { SupportCallPopupComponent } from '../../support-call-popup/support-call-popup.component'
import { MatCard } from '@angular/material/card'
import { HubChildTranslateModule } from '@inside-hub-app/hub-translate'

@Component({
  selector: 'customer-portal-app-support-vehicle-card',
  standalone: true,
  templateUrl: './support-vehicle-card.component.html',
  imports: [MatCard, HubChildTranslateModule]
})
export class SupportVehicleCardComponent {
  @Input() alwaysSmall = false

  constructor (
    public sharedService: SharedService,
    private readonly cptGtmService: CptGoogleTagmanagerService,
    private readonly dialog: MatDialog
  ) {}

  openSupportVehiclePopup (): void {
    this.dialog.open(SupportCallPopupComponent, {
      panelClass: ['mat-dialog-cpt'],
      width: '100%',
      maxWidth: '1000px',
      autoFocus: false,
      data: {}
    })
  }

  sendContentModulesCTAData (contentModuleLabel: string): void {
    this.cptGtmService.sendContentModulesData(
      'CTA',
      'Click',
      this.sharedService.translateLink(contentModuleLabel) ?? '',
      'CTA',
      this.sharedService.translateLink(contentModuleLabel) ?? ''
    )
  }

  handleSupportCallback (): void {
    this.openSupportVehiclePopup()
    this.sendContentModulesCTAData('customerPortal.customer-portal.support-vehicle-card.button')
  }
}
